
// FAQ form
(() => {
	const formField = document.querySelector('#faq-search');

	if(!formField) return;

	const params = new URLSearchParams(location.search);
	if(params.get('search')) {
		formField.value = params.get('search');
	}
})();

// FAQ accordion
(() => {
	const accordions = document.querySelectorAll('.faq-accordion');

	if(!accordions) return;

	for(const accordion of accordions) {
		accordion.addEventListener('click', e => {
			const row = e.target.closest('.faq-accordion-row');
			const openRow = accordion.querySelector('.faq-accordion-row.open');
			const isTargetHeader = !!e.target.closest('.faq-accordion-title');
			if(openRow && (openRow !== row) && isTargetHeader) {
				openRow.classList.remove('open');
				openRow.querySelector('.faq-accordion-content').style.height = '';
			}
	
			if(row && isTargetHeader) {
				row.classList.toggle('open');
				const content = row.querySelector('.faq-accordion-content');
				content.style.height = row.classList.contains('open') ? (content.scrollHeight + 'px') : '';
			}
		}, false);
	} 
})();